/* ============================================================================
   EarVue — trust badges + payment-icons row controller.
   Forked from assets/trust-badges-payment-icons.js so EarVue can carry its
   own badge copy without touching the shared BackEase file (see that
   file's header). Purely additive: does not touch the native quantity
   selector or Add to cart button -- those are hidden/resized via this
   file's companion stylesheet instead.

   Badge content below is EarVue-specific. If this is reused on a future
   product with different badge copy, fork again the same way.
   ============================================================================ */
(function () {
  'use strict';

  function insertTrustBadges() {
    if (document.querySelector('.ev-tb-trust-badges')) return; // already inserted
    var buyButtons = document.querySelector('.buy-buttons-block');
    if (!buyButtons) return;

    // Laurel-wreath seal icon (single branch; mirrored via CSS for the
    // right-hand side of each badge so only one SVG needs to be defined).
    var laurel =
      '<svg class="ev-tb-trust-seal__laurel-icon" viewBox="0 0 30 40" width="20" height="28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M15 38 C 8 30, 6 20, 10 2" stroke="currentColor" stroke-width="1.5" fill="none"/>' +
        '<ellipse cx="9" cy="8" rx="4" ry="2" transform="rotate(-30 9 8)" fill="currentColor"/>' +
        '<ellipse cx="8" cy="15" rx="4.2" ry="2.1" transform="rotate(-20 8 15)" fill="currentColor"/>' +
        '<ellipse cx="8.5" cy="22" rx="4.4" ry="2.2" transform="rotate(-10 8.5 22)" fill="currentColor"/>' +
        '<ellipse cx="10" cy="29" rx="4.6" ry="2.3" fill="currentColor"/>' +
        '<ellipse cx="13" cy="35" rx="4.8" ry="2.4" transform="rotate(15 13 35)" fill="currentColor"/>' +
      '</svg>';

    var seals = [
      { line1: '10,000+', line2: 'Customers' },
      { line1: '1080p HD', line2: 'Live View' },
      { line1: '14-Day', line2: 'Guarantee' }
    ];

    var wrap = document.createElement('div');
    wrap.className = 'ev-tb-trust-badges';
    wrap.innerHTML = seals
      .map(function (seal) {
        return (
          '<div class="ev-tb-trust-seal">' +
            '<span class="ev-tb-trust-seal__laurel ev-tb-trust-seal__laurel--left">' + laurel + '</span>' +
            '<span class="ev-tb-trust-seal__text"><strong>' + seal.line1 + '</strong><span>' + seal.line2 + '</span></span>' +
            '<span class="ev-tb-trust-seal__laurel ev-tb-trust-seal__laurel--right">' + laurel + '</span>' +
          '</div>'
        );
      })
      .join('');

    buyButtons.insertAdjacentElement('afterend', wrap);
  }

  function repositionPaymentIcons() {
    var icons = document.querySelector('.atc-payment-icons');
    var checkoutBlock = document.querySelector('.accelerated-checkout-block');
    if (!icons || !checkoutBlock) return;
    checkoutBlock.insertAdjacentElement('afterend', icons);
  }

  function boot() {
    insertTrustBadges();
    repositionPaymentIcons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
